const detectBrowser = () => {
  if (window.navigator.userAgent.match(/MSIE|Trident/) !== null) return 'ie'
  else return null
}

export default detectBrowser
